import SystemFieldProto from '../../proto/system-field-proto';
import Moment from "moment";
import AggregateMoment from "../../aggregate/aggregate-moment";
import AggregateMomentComponent from "../components/aggregate-moment";


export default class LastUpdatedField extends SystemFieldProto {

    constructor(entityType) {
        super(entityType);
        this.type = gd.const.fields.type.LAST_UPDATED;
    }

    get sortHintMessage() {
        return 'Sort by last updated date';
    }

    getCsvValue(item) {
        return Moment(item.recentActivityMoment).format("YYYY-MM-DD");
    }

    getValue(item) {return item.recentActivityMoment}

    getAggregateClass() {return AggregateMoment}
    getAggregateOptions() {return [
        gd.const.aggregate.type.MIN,
        gd.const.aggregate.type.MAX,
        gd.const.aggregate.type.RANGE
    ]}

    listItemSortFunctions(sort) {
        return {
            functions: [i => !i.item.recentActivityMoment ? 0 : -i.item.recentActivityMoment.unix()],
            directions: [sort]
        }
    }

    get AggregateComponent() {return AggregateMomentComponent.bind(null, this.getAggregateOptions())}
}